import { FC, useMemo } from 'react';

import dayjs from 'dayjs';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';

import GmailEntry from './EmailEntry/GmailEntry';
import OutlookEntry from './EmailEntry/OutlookEntry';

dayjs.extend(LocalizedFormat);

export type EmailEntryProps = {
  data: Record<string, any>;
  onClick?: () => void;
};

const EmailEntry: FC<EmailEntryProps> = ({ data, onClick }) => {
  const emailEntrytoRender = useMemo(() => {
    switch (data.source) {
      case 'GOOGLE':
        return <GmailEntry data={data as any} onClick={onClick} />;
      case 'AZURE':
        return <OutlookEntry data={data as any} onClick={onClick} />;
      default:
        return <GmailEntry data={data as any} onClick={onClick} />;
    }
  }, [data, onClick]);

  return emailEntrytoRender;
};

export default EmailEntry;
